import React from "react";
import Slider from "react-rangeslider";
import CreditImg from "./../media/credit_personal.jpg";
import { PageHeader } from "./../Components";
export default class PersonalCredit extends React.PureComponent {
  state = {
    items: [
      {
        title: "Konut Kredisi"
      },
      {
        title: "Taşıt Kredisi"
      },
      {
        title: "Maaş Teminatlı Krediler"
      },
      {
        title: "Sıcak Kredi"
      },
      {
        title: "İhtiyaç Kredisi"
      },
      {
        title: "Tüketici Kredisi"
      },
      {
        title: "Nova Ekstra Kredi"
      },
      {
        title: "Nova Eğitim Kredisi"
      }
    ],
    currentTab: {
      title: "Konut Kredisi"
    },
    vade_suresi: ""
  };
  handleChangeVadeSuresi = value => {
    this.setState({
      vade_suersi: value
    });
  };
  handleChangeKrediTutari = value => {
    this.setState({
      kredi_tutari: value
    });
  };
  navigate = item => {
    this.setState({
      currentTab: item
    });
  };
  render = () => (
    <div>
      <PageHeader
        headerClass={"personal_banking"}
        pageName="Bireysel Bankacılık"
      />
      <div className="container about_us_wrapper mt80 mb80">
        <div className="col-3 calculation_sidebar">
          <p className="header">Örnek Hesaplama</p>
          <div className="money_selection_radio">
            <label className="custom-input">
              <input type="radio" name="radioFoo" value="1" />
              <span className="check-radio" />
              <span className="custom-input-label">TL</span>
            </label>
            <label className="custom-input">
              <input type="radio" name="radioFoo" value="2" />
              <span className="check-radio" />
              <span className="custom-input-label">EUR</span>
            </label>
            <label className="custom-input">
              <input type="radio" name="radioFoo" value="2" />
              <span className="check-radio" />
              <span className="custom-input-label">USD</span>
            </label>
            <label className="custom-input">
              <input type="radio" name="radioFoo" value="2" />
              <span className="check-radio" />
              <span className="custom-input-label">GBP</span>
            </label>
          </div>
          <p className="section_header mt60">Vade Süresi</p>
          <div className="slider orientation-reversed">
            <div className="slider-group">
              <div className="slider-horizontal">
                <Slider
                  min={0}
                  max={200}
                  value={this.state.vade_suersi}
                  orientation="horizontal"
                  onChange={this.handleChangeVadeSuresi}
                />
              </div>
              <div className="slider_value">{this.state.vade_suersi} Ay</div>
            </div>
          </div>
          <p className="section_header mt120">Kredi Tutarı</p>
          <div className="slider orientation-reversed">
            <div className="slider-group">
              <div className="slider-horizontal">
                <Slider
                  min={0}
                  max={100000}
                  value={this.state.kredi_tutari}
                  orientation="horizontal"
                  onChange={this.handleChangeKrediTutari}
                />
              </div>
              <div className="slider_value">{this.state.kredi_tutari} TL</div>
            </div>
          </div>
          <button className="calculate-btn mt150">HESAPLA</button>
          <div className="result">
            <p className="section_header mt30">Aylık Ödeme Tutarı</p>
            <p className="result_value">278.31 TL</p>
            <p className="section_header mt30">Toplam Ödeme Tutarı</p>
            <p className="result_value">13,358.76 TL</p>
            <p className="calculation_method_description">
              Kredinin hesaplanmasında komisyon ve BSİV ücretleri dahil
              edilmemiştir. Detaylı bilgi ve uygun kredi faiz oranları için
              şubelerimizi ziyaret edebilir veya müşteri temsilcilerimizi
              arayabilirsiniz. Bankamızın faiz, ücretler ve vadeyi değiştirme
              hakkı saklıdır.
            </p>
          </div>
        </div>
        <div className="col-6">
          <img alt="" src={CreditImg} />
          <p className="title">{this.state.currentTab.title}</p>
          <p className="description">
            Bankamız 25 Kasım 1992 yılında FİNBA-FİNANSAL BANK LİMİTED olarak
            kurulmuş 14 Şubat 2000 tarihinde ismini ARTAM BANK LTD. olarak
            değiştirmiştir. O yıllarda küçük hacmi ve personel sayısıyla sınırlı
            hizmet sunan Bankamız 12 Ekim 2012 tarihinde LEVENT ŞİRKETLER GRUBU
            bünyesine dahil edilerek, hızlıca büyüme sağlamıştır. Genel Müdürlük
            ile birlikte toplam (7) merkezde kaliteli hizmet sunan Bankamızın
            nitelikli pay sahipleri, adanın çeşitli sektörlerinde hizmet sunan
            saygıdeğer iş insanları Sn. Mehmet Boyacı ve Sn. Mete Boyacı'dır.
          </p>
          <p className="description">
            Adanın ulaşılabilir şehir merkezlerinde ve Uluslararası Kıbrıs
            Üniversitesi'nde toplam 6 şubemiz bulunmaktadır. Hizmetlerimizi 65
            adet değerli personelimiz aracılığıyla vermekte olup, müşteri
            memnuniyeti anlayışımız ve tüm sektörlere hitap eden kredi ve
            mevduat türlerimiz ile siz değerli müşterilerimizin nabzını
            tutmaktayız.
          </p>
        </div>
        <div className="col-3 navigation_tab">
          <ul>
            {this.state.items.map((item, key) => (
              <li
                className={
                  this.state.currentTab.title === item.title ? "active" : ""
                }
                onClick={() => this.navigate(item)}
                key={key}
              >
                {item.title}
                {/* {this.state.currentTab.title === item.title ?  <img src={leftArrowFullWhite}/>  : <img src={leftArrowFullGray}/> } */}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="help_section mt80">
        <p className="title">Size Nasıl Yardımcı Olabiliriz?</p>
        <div className="container">
          <div className="row mt50">
            <div className="col-4 contact_info_item">
              <div className="graphic phone" />
              <div className="content">
                <p className="item_title">Biz Sizi Arayalım</p>
              </div>
            </div>
            <div className="col-4 contact_info_item">
              <div className="graphic form" />
              <div className="content">
                <p className="item_title">İletişim Formu ile Ulaşın</p>
              </div>
            </div>
            <div className="col-4 contact_info_item">
              <div className="graphic person" />
              <div className="content">
                <p className="item_title">Yüz Yüze İletişim</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
